/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PersonDataAliases {
  FRAGMENT_DETALHES = 'fragment-detalhes',
  FRAGMENT_DETALHES_INCOMPLETO = 'fragment-detalhes-incompleto',
  FRAGMENT_SOLICITACOES_ALTERACOES = 'fragment-solicitacoes-alteracoes',
  PERSON_DATA_LAYOUT = 'person-data-layout',
  PERSON_DATA_MENU_TAB_CONTROL = 'person-data-menu-tab-control',
  PERSON_DATA_MENU_TAB_CONTROL_HIDDEN = 'person-data-menu-tab-control-hidden',
  PERSON_DATA_TAB_PANEL_N = 'person-data-tab-panel-n',
  PERSON_DATA_TAB_PANEL_S = 'person-data-tab-panel-s',
  TAB_WITH_CONTENT_DETALHES = 'tab-with-content-detalhes',
  TAB_WITH_CONTENT_DETALHES_INCOMPLETO = 'tab-with-content-detalhes-incompleto',
  TAB_WITH_CONTENT_SOLICITACOES_ALTERACOES = 'tab-with-content-solicitacoes-alteracoes',
}
export { PersonDataAliases };
